module.exports = __webpack_public_path__ + "static/img/bc1-4.4feb25d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-4.png
// module id = 821
// module chunks = 0